<template>
    <div>
        <a-alert v-if="errorMessage" type="error" :message="errorMessage" banner closable
            @close="errorMessage = null" />

        <!-- filter -->
        <ARow :gutter="[8, 8]">
            <!-- <ACol :xl="6" :md="8" :sm="12">
                <ASelect v-model:value="state.params.distributorType" :options="distributorTypeOptions"
                    style="width: 100%" placeholder="Semua Tipe Distributor" allow-clear />
            </ACol> -->
            <ACol :xl="6" :md="8" :sm="12">
                <FilterDistributorDerivatives :type="1113" style="width:100%;"
                    v-model:value="state.params.distributor_id" v-model:kabupaten="state.params.kabupaten"
                    v-model:area="state.params.area" v-model:provinsi="state.params.provinsi" />
            </ACol>
            <ACol :xl="6" :md="8" :sm="12">
                <ASelect :options="state.statusLists" allow-clear style="width:100%;" placeholder="Pilih Status"
                    v-model:value="state.params.status" />
            </ACol>
            <ACol :xl="6" :md="8" :sm="12">
                <AInputSearch v-model:value="state.params.q" placeholder="Cari..." style="width:100%" />
            </ACol>
            <ACol :xl="6" :md="8" :sm="12">
                <AButton type="primary" title="cari" @click="fetchDataList" :loading="state.isFetching">
                    <span v-if="!state.isFetching" class="fa fa-search" aria-hidden="true" />
                    <span v-else>
                        Memuat Data ...
                    </span>
                </AButton>
            </ACol>
        </ARow>

        <!-- button action menu -->
        <div class="row justify-content-end mt-4">
            <div class="col-lg-6 col-md-12"></div>
            <div class="col-lg-6 col-md-12 text-right">
                <ASpace>
                    <ATooltip title="Tambahkan">
                        <AButton type="primary" @click="btnForm">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </AButton>
                    </ATooltip>
                    <AButton title="Upload Mapping Sales Person" type="primary" @click="btnUpload"
                        v-has-access="['vendor-user.upload']">
                        <i class="fa fa-upload" aria-hidden="true"></i>
                    </AButton>
                    <ATooltip title="Download excel">
                        <DownloadExcel :url="state.endpoint" :params="state.params"
                            namefile="Master-Data-Project-Derivatives" @errors="errorMessage" />
                    </ATooltip>
                </ASpace>
            </div>
        </div>

        <!-- list tabel -->
        <div class="table-responsive mt-4">
            <md-table :columns="state.columns" :data-source="state.data" size="small" row-key="id"
                :loading="state.isFetching" :meta="state.meta" @change="handleTableChange">

                <template #status="{ text }">
                    <ATag v-if="text === 'Aktif'" color="#108ee9">Aktif</ATag>
                    <ATag v-else color="grey">Tidak Aktif</ATag>
                </template>

                <template #action="{ record }">
                    <ASpace>
                        <ATooltip title="Edit">
                            <AButton class="button" size="small" @click="btnForm(record)">
                                <i class="fe fe-edit" />
                            </AButton>
                        </ATooltip>
                        <ATooltip title="Lihat">
                            <AButton class="button" size="small" @click="btnForm(record, true)">
                                <i class="fe fe-eye" />
                            </AButton>
                        </ATooltip>
                        <ATooltip :title="record.deleted_at ? 'Aktifkan' : 'Nonaktifkan'">
                            <AButton class="button" size="small" @click="updateStatus(record)">
                                <i :class="record.deleted_at ? 'fe fe-refresh-cw' : 'fe fe-slash'" />
                            </AButton>
                        </ATooltip>
                        <!-- <ATooltip title="Hapus">
                            <AButton danger size="small" @click="hapus(record)">
                                <i class="fe fe-trash-2" />
                            </AButton>
                        </ATooltip> -->
                    </ASpace>
                </template>
            </md-table>
        </div>
    </div>

    <!-- form -->
    <Form v-if="visibleFormModal" v-model:visible="visibleFormModal" v-model:item="visibleFormItemModal"
        @success="fetchDataList" />

    <!-- upload -->
    <Upload v-if="visibleUploadModal" v-model:visible="visibleUploadModal" @success="fetchDataList" />

</template>
<script>
import Form from './Form'
import { defineComponent, ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import apiClient from '@/services/axios'
import { Modal, message } from 'ant-design-vue'
import Upload from './Upload'
import DownloadExcel from '@/components/Molecules/DownloadExcel'
import { updateUrlWithQuery, extractQueryParams } from '@/helpers/queryparams'
import FilterDistributorDerivatives from '@/components/filter/FilterDistributorDerivatives'

export default defineComponent({
    components: {
        FilterDistributorDerivatives,
        DownloadExcel,
        Form,
        Upload,
    },
    setup() {
        const errorMessage = ref()
        const router = useRouter()
        const state = reactive({
            columns: [
                {
                    title: 'No',
                    slots: { customRender: 'no' },
                },
                {
                    title: 'Kode',
                    dataIndex: 'code',
                },
                {
                    title: 'No Referensi - SAP / Shipto',
                    dataIndex: 'reference_number',
                },
                {
                    title: 'Tanggal Registrasi',
                    dataIndex: 'register_date',
                },
                {
                    title: 'Nama',
                    dataIndex: 'name',
                },
                {
                    title: 'Alamat',
                    dataIndex: 'address',
                },
                {
                    title: 'Wilayah',
                    dataIndex: 'wilayah_name',
                },
                {
                    title: 'Distributor',
                    dataIndex: 'distributor_label',
                },
                {
                    title: 'KAM Derivatives',
                    dataIndex: 'kam_label',
                },
                {
                    title: 'SM Derivatives',
                    dataIndex: 'sm_label',
                },
                {
                    title: 'GM Derivatives',
                    dataIndex: 'gm_label',
                },
                {
                    title: 'Segment',
                    dataIndex: 'segment_label',
                },
                {
                    title: 'Status',
                    dataIndex: 'status',
                    slots: { customRender: 'status' },
                },
                {
                    title: 'Action',
                    slots: { customRender: 'action' },
                },
            ],
            endpoint: '/api/derivatives/projects',
            params: extractQueryParams({
                q: '',
                type: 1,
                distributorType: undefined,
                status: null,
                page: 1,
                'per-page': 10,
            }),
            data: [],
            statusLists: [
                { value: 1, label: 'Aktif' },
                { value: 0, label: 'Tidak Aktif' },
            ],
            meta: null,
            isFetching: false,
        })

        // fetch list data
        const fetchDataList = () => {
            state.isFetching = true

            apiClient
                .get(state.endpoint, {
                    params: {
                        ...updateUrlWithQuery(state.params),
                        type: 1,
                        distributorType: state.params.distributorType,
                        status: state.params.status,
                    },
                })
                .then(({ data }) => {
                    const { items, _meta } = data

                    state.data = items
                    state.meta = _meta
                })
                .finally(() => {
                    state.isFetching = false
                })
        }

        const distributorTypeOptions = [
            { value: null, label: 'Semua' },
            { value: 1112, label: 'Distributor Derivatives Mortar Retail' },
            { value: 1113, label: 'Distributor Derivatives Mortar Project & BIP' },
        ]

        // handle form
        const visibleFormModal = ref(false);
        const visibleFormItemModal = ref(null);

        const btnForm = (item = null, readOnly = false) => {
            visibleFormModal.value = true;
            visibleFormItemModal.value = {
                ...item,
                readOnly,
            };
        };

        const updateStatus = (record) => {
            Modal.confirm({
                title: 'Konfirmasi',
                content: record.deleted_at
                    ? 'Aktifkan kembali data ini?'
                    : 'Nonaktifkan data ini?',

                async onOk() {
                    await apiClient.put(`${state.endpoint}/${record.id}/status`)

                    message.success('Status berhasil diubah')

                    fetchDataList()
                },
            })
        }

        // handle vue
        onMounted(() => {
            fetchDataList()
        })

        // handle upload
        const visibleUploadModal = ref(false);

        const btnUpload = () => {
            visibleUploadModal.value = true
        }

        const handleTableChange = (pagination) => {
            state.params.page = pagination.current
            state.params['per-page'] = pagination.pageSize

            fetchDataList()
        }

        return {
            visibleFormModal,
            visibleFormItemModal,
            errorMessage,
            fetchDataList,
            btnForm,
            btnUpload,
            visibleUploadModal,
            updateStatus,
            state,
            distributorTypeOptions,
            handleTableChange,
        }
    },
})
</script>
<style scoped></style>